import { DATA_RECEIVED_EVENT_KEY, FETCHING_DATA_EVENT_KEY } from "../constants";

// ============================= Country class ============================= //

class Country {
  avg_score = undefined;
  companies = 0;
  db_id = "";
  db_name = "";
  is_region = false;
  entities = [];
  fetchingData = false;
  id = "";
  name = "";
  trade_associations = 0;
  influencers = 0;

  constructor(_data) {
    if (_data) {
      this.name = _data.name;
      this.id = _data.id;
    }
  }

  updateInformation(_data) {
    this.avg_score = _data?.country?.avg_score.toFixed(2);
    this.db_id = _data?.country?.id ?? "";
    this.db_name = _data?.country?.name ?? "";
    this.is_region = _data?.country?.region ?? false;
    this.entities = _data?.entities || [];
    this.fetchingData = false;

    if (_data?.entities?.length > 0) {
      this.companies = _data?.entities?.filter(
        (entity) => entity.entity_type === "company",
      );
      this.trade_associations = _data?.entities?.filter(
        (entity) => entity.entity_type === "trade_association",
      );
      this.influencers = _data?.entities?.filter(
        (entity) => entity.entity_type === "influencer",
      );
    }

    // Dispatch event with fetched data when received
    const event = new CustomEvent(DATA_RECEIVED_EVENT_KEY, {
      detail: { countryName: this.name, ...(_data || {}) },
    });
    document.dispatchEvent(event);
  }

  setFetchingData(bool) {
    this.fetchingData = bool;

    // Dispatch event when starting to fetch data
    if (bool === true) {
      const event = new Event(FETCHING_DATA_EVENT_KEY);
      document.dispatchEvent(event);
    }
  }
}

export default Country;
